/** The kinds of payload the QR generator can encode. */
export type QrType = 'url' | 'text' | 'email' | 'phone' | 'sms' | 'whatsapp' | 'wifi' | 'vcard' | 'event' | 'location'

export interface QrTypeMeta {
  id: QrType
  labelKey: string
}

export const QR_TYPES: readonly QrTypeMeta[] = [
  {id: 'url', labelKey: 'url'},
  {id: 'text', labelKey: 'text'},
  {id: 'email', labelKey: 'email'},
  {id: 'phone', labelKey: 'phone'},
  {id: 'sms', labelKey: 'sms'},
  {id: 'whatsapp', labelKey: 'whatsapp'},
  {id: 'wifi', labelKey: 'wifi'},
  {id: 'vcard', labelKey: 'vcard'},
  {id: 'event', labelKey: 'event'},
  {id: 'location', labelKey: 'location'},
]
